import React from 'react';
import { Dayjs } from 'dayjs';
import styled from 'styled-components';
import { Text } from 'components/Typography';
import { theme } from 'design';
import { IPaymentTotals } from 'types';
import { centsToDollarsDisplay, formatDateForUILongFormat } from 'utils';
import Sidebar, { ISidebarNotification } from './components/Sidebar';
import { RowItem as BaseRowItem, Content } from './components/styles';

interface IPaymentInputSidebarProps {
  dataCy?: string;
  businessDate: Dayjs;
  continueDisabled?: boolean;
  showCash?: boolean;
  totals?: IPaymentTotals;
  notifications?: ISidebarNotification[];
  onBack: () => void;
  onContinue?: () => void;
}

const RowItem = styled(BaseRowItem)`
  &.gross {
    p {
      color: ${theme.color.neutral[900]};
    }
  }
`;

const PaymentInputSidebar = ({ businessDate, totals, notifications, showCash = true, onBack, onContinue, continueDisabled = false, dataCy = 'payment-input-sidebar' }: IPaymentInputSidebarProps) => (
  <Sidebar
    title="Payment Details"
    leftActionButton={{ label: 'Back', appearance: 'white', onClick: onBack }}
    rightActionButton={onContinue ? { label: 'Continue', appearance: 'primary', disabled: continueDisabled || notifications?.some((notification) => notification.preventSubmit), onClick: onContinue } : undefined}
    notifications={notifications}
    dataCy={dataCy}
  >
    <Content>
      <RowItem data-cy={`${dataCy}-business-date`} className="business-date">
        <Text size="small" data-cy={`${dataCy}-business-date-label`}>
          Business Date:
        </Text>
        <Text size="small" data-cy={`${dataCy}-business-date-value`}>
          {formatDateForUILongFormat(businessDate)}
        </Text>
      </RowItem>
      <RowItem data-cy={`${dataCy}-gross`} className="gross">
        <Text size="small" data-cy={`${dataCy}-gross-label`} fontWeight="medium">
          Amount Entered (Gross)
        </Text>
        <Text size="small" data-cy={`${dataCy}-gross-value`} fontWeight="medium">
          {centsToDollarsDisplay(totals?.gross ?? 0)}
        </Text>
      </RowItem>
      {showCash && (
        <RowItem data-cy={`${dataCy}-cash`}>
          <Text size="small" color={theme.color.neutral[500]} data-cy={`${dataCy}-cash-label`}>
            Cash
          </Text>
          <Text size="small" data-cy={`${dataCy}-cash-value`}>
            {centsToDollarsDisplay(totals?.cash ?? 0)}
          </Text>
        </RowItem>
      )}
      <RowItem data-cy={`${dataCy}-payroll`}>
        <Text size="small" color={theme.color.neutral[500]} data-cy={`${dataCy}-payroll-label`}>
          Payroll
        </Text>
        <Text size="small" data-cy={`${dataCy}-payroll-value`}>
          {centsToDollarsDisplay(totals?.payroll ?? 0)}
        </Text>
      </RowItem>
      <RowItem data-cy={`${dataCy}-instant`}>
        <Text size="small" color={theme.color.neutral[500]} data-cy={`${dataCy}-instant-label`}>
          Instant
        </Text>
        <Text size="small" data-cy={`${dataCy}-instant-value`}>
          {centsToDollarsDisplay(totals?.instant ?? 0)}
        </Text>
      </RowItem>
    </Content>
  </Sidebar>
);

export default PaymentInputSidebar;
